export default "__VITE_ASSET__BSpDH2Qf__"